import React, {useEffect, useState} from "react";
import {Autocomplete, Card, CardContent, Grid, TextField} from "@mui/material";
import {Controller, useFormContext} from "react-hook-form";
import {CarTypeSelect} from "~/apps/packages/passes/components/PassForm/CarTypeSelect";
import {Values} from "./PassForm";
import {useAdmissionCarList} from "~/apps/packages/passes/hooks";
import {ArrayElement} from "~/types";
import {useDebounce} from "@react-hook/debounce";

export type CarFormCardProps = {}


export const CarFormCard = (props: CarFormCardProps) => {
    const {control, watch, setValue, errors} = useFormContext<Values>();
    const carRegNumber = watch("carRegNumber");
    const [query, setQuery] = useDebounce(carRegNumber, 180, false);
    const {data: cars} = useAdmissionCarList({
        query: query
    });
    type Car = ArrayElement<ReturnType<typeof useAdmissionCarList>["data"]>;
    const [selectedCar, setSelectedCar] = useState<Car>();

    // load suggestions
    useEffect(() => {
        setQuery(carRegNumber);
    }, [carRegNumber])

    // update data from suggestion
    useEffect(() => {
        if (selectedCar) {
            const newValues: Partial<Values> = {
                carRegNumber: selectedCar.regNumber,
                carBrand: selectedCar.brand,
                carColor: selectedCar.color,
                carType: Number(selectedCar.type),
                carModel: selectedCar.model
            }
            for (const [fieldName, value] of Object.entries(newValues)) {
                setValue(fieldName as keyof typeof newValues, value, {shouldValidate: true});
            }
        }
    }, [selectedCar, setValue]);

    return (
        <Card>
            <CardContent>
                <Grid container direction="column" spacing={2}>
                    <Grid item>
                        <Controller
                            name="carRegNumber"
                            control={control}
                            rules={{required: "Обязательно для заполнения", maxLength: 15}}
                            render={({onChange, value, name, ref}) => (
                                <Autocomplete
                                    freeSolo
                                    // @ts-ignore
                                    value={selectedCar as Car}
                                    inputValue={value || ""}
                                    onInputChange={(e, value) => {
                                        onChange(value.toUpperCase());
                                    }}
                                    onChange={(e, value) => {
                                        setSelectedCar(value as any);
                                    }}
                                    getOptionLabel={(option: Car) => option.regNumber}
                                    isOptionEqualToValue={(option, value) => option.regNumber == value?.regNumber}
                                    disableClearable
                                    renderInput={props => (
                                        <TextField {...props} label="Гос.номер"
                                                   placeholder="О123НК 125"
                                                   inputProps={{
                                                       ...props.inputProps,
                                                       maxLength: 15,
                                                   }}
                                                   error={Boolean(errors?.[name])}
                                                   helperText={errors?.[name]?.message}
                                                   inputRef={ref}

                                        />
                                    )}
                                    fullWidth
                                    options={cars || []}
                                    filterOptions={options => options}
                                    blurOnSelect
                                />
                            )}
                        />
                    </Grid>
                    <Grid item>
                        <Controller
                            name="carType"
                            control={control}
                            rules={{required: "Обязательно для заполнения"}}
                            render={({onChange, value, name, ref}) => (
                                <CarTypeSelect
                                    label="Тип автомобиля"
                                    fullWidth
                                    value={value}
                                    onChange={onChange}
                                    error={Boolean(errors?.[name])}
                                    helperText={errors?.[name]?.message}
                                    inputRef={ref}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item>
                        <Controller
                            name="carBrand"
                            control={control}
                            rules={{required: "Обязательно для заполнения"}}
                            render={({onChange, value, name, ref}) => (
                                <TextField
                                    label="Марка"
                                    placeholder="Toyota"
                                    fullWidth
                                    inputProps={{maxLength: 32}}
                                    value={value}
                                    onChange={onChange}
                                    error={Boolean(errors?.[name])}
                                    helperText={errors?.[name]?.message}
                                    inputRef={ref}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item>
                        <Controller
                            name="carModel"
                            control={control}
                            rules={{required: "Обязательно для заполнения"}}
                            render={({onChange, value, name, ref}) => (
                                <TextField
                                    label="Модель"
                                    placeholder="Land Cruiser"
                                    fullWidth
                                    inputProps={{maxLength: 32}}
                                    value={value}
                                    onChange={onChange}
                                    error={Boolean(errors?.[name])}
                                    helperText={errors?.[name]?.message}
                                    inputRef={ref}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item>
                        <Controller
                            name="carColor"
                            control={control}
                            rules={{required: "Обязательно для заполнения"}}
                            render={({onChange, value, name, ref}) => (
                                <TextField
                                    label="Цвет"
                                    placeholder="Черный"
                                    fullWidth
                                    inputProps={{maxLength: 32}}
                                    value={value}
                                    onChange={onChange}
                                    error={Boolean(errors?.[name])}
                                    helperText={errors?.[name]?.message}
                                    inputRef={ref}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}
